import React, { FC, useEffect } from 'react';
import { ReportingDetailsVerificationStatusesTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import {
  deleteVerificationStatus,
  fetchVerificationStatuses,
} from '../../../store/landscapeAPI/verificationStatus/reducers/verification-status.slice';
import styles from './ReportingDetailsVerificationStatusesPage.module.css';
import cn from 'classnames';

interface ReportingDetailsVerificationStatusesPageProps {}

const ReportingDetailsVerificationStatusesPage: FC<
  ReportingDetailsVerificationStatusesPageProps
> = () => {
  const { verificationStatuses, status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchVerificationStatuses());
  }, [dispatch]);

  const handleDeleteVerificationStatus = (id: string) => {
    dispatch(deleteVerificationStatus(id));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <ReportingDetailsVerificationStatusesTemplate
        data={verificationStatuses || []}
        handleDeleteVerificationStatus={handleDeleteVerificationStatus}
      />
    </div>
  );
};

export default ReportingDetailsVerificationStatusesPage;
